var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSvgGuestRulesGrShieldCheck = function SvgSvgGuestRulesGrShieldCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 3.775v7.637A12.285 12.285 0 0 0 9.828 22.88l1.067.414c.711.275 1.5.275 2.21 0l1.067-.414A12.285 12.285 0 0 0 22 11.412V3.775a1.535 1.535 0 0 0-.89-1.406A22.143 22.143 0 0 0 12 .5a22.143 22.143 0 0 0-9.11 1.869A1.536 1.536 0 0 0 2 3.775Z",
    fill: "#78EB7B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 .5a22.143 22.143 0 0 0-9.11 1.869A1.536 1.536 0 0 0 2 3.775v7.637A12.285 12.285 0 0 0 9.828 22.88l1.067.414c.353.136.727.206 1.105.206V.5Z",
    fill: "#C9F7CA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 3.775v7.637A12.285 12.285 0 0 0 9.828 22.88l1.067.414c.711.275 1.5.275 2.21 0l1.067-.414A12.285 12.285 0 0 0 22 11.412V3.775a1.535 1.535 0 0 0-.89-1.406A22.143 22.143 0 0 0 12 .5a22.143 22.143 0 0 0-9.11 1.869A1.536 1.536 0 0 0 2 3.775v0Z",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m17.5 7-6.035 8.732-4.578-4.58",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgSvgGuestRulesGrShieldCheck;